<template>
  <div class="ownerInfo">
    <review-card name="ownerInfoEdit" :editable="false">
      <template #title>{{ t('title') }}</template>

      <ownership-table
        :owners="currentOwners"
        :totalOwnershipValue="totalPercentOwnership"
        @input="updateOwner"
        @click="jumpToSection"
      />
    </review-card>
  </div>
</template>
<script>
import ReviewCard from '@/components/ReviewCard';
import OwnershipTable from '@/components/OwnershipTable';
import buildTranslators from '@/utils/build-translators';

export default {
  name: 'owners-info',
  components: {
    ReviewCard,
    OwnershipTable,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    totalPercentOwnership: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showEditModal: false,
      currentOwners: [],
    };
  },
  computed: {
    owners: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  created() {
    this.currentOwners = this.owners;
  },
  watch: {
    owners(newOwners) {
      this.currentOwners = newOwners;
    },
  },
  methods: {
    onModalClose() {
      this.showEditModal = false;
      this.$emit('modalClose');
    },
    t(key, options) {
      return buildTranslators('reviewSubmit.card.ownerInfo').t(key, options);
    },
    updateOwner(value) {
      const index = this.currentOwners.findIndex(owner => owner.id === value.id);

      if (index !== -1) {
        this.currentOwners.splice(index, 1, value);
      }

      this.owners = this.currentOwners;
    },
    jumpToSection(id) {
      const section = document.getElementById(id);

      section.scrollIntoView();
      this.$emit('jumpToSection', id);
    },
  },
};
</script>
<style lang="sass" scoped></style>
